// Detect if we're in development mode
const isDevelopment = import.meta.env.DEV || window.location.hostname === 'localhost';

// Production API configuration for the AI Companion System
export const API_CONFIG = {
  // Main API endpoint - handles chat, export, delete, etc.
  API_BASE_URL: 'https://ai-companion-edge-auth-production.blomst.workers.dev',
  
  // Auth endpoint - handles magic link authentication and JWT tokens
  AUTH_BASE_URL: 'https://ai-companion-edge-auth-production.blomst.workers.dev',
  
  // LLM Gateway endpoint (if needed for direct calls)
  LLM_GATEWAY_URL: 'https://companion-llm-gateway-production.blomst.workers.dev',
  
  // Background jobs endpoint (for monitoring, if needed)
  BACKGROUND_JOBS_URL: 'https://ai-companion-background-production.blomst.workers.dev',
  
  // Environment detection
  IS_PRODUCTION: !isDevelopment,
  
  // WebSocket/SSE configuration
  STREAM_CONFIG: {
    withCredentials: true,
    reconnectAttempts: 5,
    reconnectDelay: 1000,
  },
  
  // JWT token configuration
  TOKEN_CONFIG: {
    cookieName: 'companion_auth',
    localStorageKey: 'auth_token',
    headerName: 'Authorization',
  }
};

// Helper function to get the correct API base URL
export function getApiBaseUrl(): string {
  return API_CONFIG.API_BASE_URL;
}

// Helper function to get the correct auth base URL
export function getAuthBaseUrl(): string {
  return API_CONFIG.AUTH_BASE_URL;
}

// Helper function to build API URLs
export function buildApiUrl(path: string): string {
  return `${getApiBaseUrl()}${path}`;
}

// Helper function to build auth URLs
export function buildAuthUrl(path: string): string {
  return `${getAuthBaseUrl()}${path}`;
}